<template>
    <header class="top-header">
        <div class="mask-nav" v-show="navShow">
            <ul class="nav-list">
                <li v-for="(nav, index) in navList" :key="index" @click="goto(nav)">
                    <a href="javascript:void(0)">{{isCn?nav.navigateCnName:nav.navigateEnName}}</a>
                </li>
                <li><span :class="isCn?'active':''" @click="changeLang('cn')">中文</span> / <span :class="isCn?'':'active'" @click="changeLang('en')">EN</span></li>
            </ul>
            <i class="close-btn" @click="toggleNav"></i>
        </div>
        <div class="top-nav">
            <router-link :to="{ name: 'home' }" class="top-logo">
                <img :src="logo" alt="">
            </router-link>
            <div class="top-menu" @click="toggleNav">
                <img :src="navShow?menuActive:menu" alt="">
            </div>
        </div>
    </header>
</template>

<script>
import logoSrc from '@/style/image/logo.png';
import menuSrc from '@/style/image/menu.png';
import menuActiveSrc from '@/style/image/menu_active.png';
import ajax from '@/utils/ajax';

export default {
    name: 'layout-head',
    components: {
        // Layout,
    },
    data() {
        return {
            isCn: window.localStorage.getItem('show-lang') !== 'en',
            navShow: false,
            navList: [],
            logo: logoSrc,
            menu: menuSrc,
            menuActive: menuActiveSrc,
        };
    },
    mounted() {
        const self = this;
        ajax.get('/web/common/navigate_list.json', { id: 0 }).then((result) => {
            this.navList = result.data.sonNavigateList;
        }).catch(() => {});
        ajax.get('/web/common/logo.json', {}).then((result) => {
            if (result.data) {
                self.logo = result.data;
            }
        }).catch(() => {});
    },
    methods: {
        toggleNav() {
            this.navShow = !this.navShow;
        },
        goto(nav) {
            if (nav.documentUrl === 'home') {
                this.$router.push({ name: 'home' });
            } else {
                ajax.get('/web/common/navigate_list.json', { id: nav.navigateId }).then((result) => {
                    if (result.data.sonNavigateList.length === 0) {
                        return;
                    }
                    if (nav.systemFlag === 1) {
                        this.$router.push({ name: nav.documentUrl });
                    } else if (nav.documentUrl && !nav.documentId) {
                        this.$router.push({ name: nav.documentUrl, params: { id: nav.navigateId } });
                    } else {
                        this.$router.push({ name: 'customNav', params: { id: nav.navigateId } });
                    }
                }).catch(() => {});
            }
            this.navShow = false;
        },
        changeLang(lang) {
            if (window.localStorage) {
                window.localStorage.setItem('show-lang', lang);
            }
            document.location.reload();
        },
    },
};
</script>
<style lang="less" scoped>
    .top-header {
        width: 100%;
        height: 100%;
    }
    .top-nav {
        width: 100%;
        height: 100%;
        background: #C71F4B;
        display: flex;
        justify-content: space-between;
        align-content: center;
        position: relative;
        z-index: 3;
        .top-logo {
            width: 22px;
            height: 26px;
            margin-top: 12px;
            margin-left: 26px;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .top-menu {
            width: 26px;
            height: 26px;
            margin-top: 12px;
            margin-right: 26px;
            img {
                width: 100%;
                height: 100%;
            }
        }
    }
    .mask-nav {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        padding-top: 50px;
        padding-bottom: 72px;
        background: rgba(0,0,0,.90);
        z-index: 2;
        .nav-list {
            height: 100%;
            overflow-y: auto;
            li {
                width: 100%;
                height: 50px;
                line-height: 50px;
                text-align: center;
                color: #fff;
                background: #4A4A4A;
                margin-bottom: 1px;
                font-size: 15px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                a {
                    color: #fff;
                }
                span.active {
                    color: #C71F4B;
                }
            }
        }
        .close-btn {
            position: absolute;
            bottom: 42px;
            left: 50%;
            transform: translate(-50%, 0);
            width: 30px;
            height: 30px;
            background: url('../style/image/close_menu.png') 50% 50% no-repeat;
            background-size: contain;
        }
    }
</style>
